import type { FunctionComponent } from 'react';
import { usePropertyPageQuery } from '../../graphql/usePropertyPageQuery';
import { GovernmentOverlaysBrick } from './GovernmentOverlaysBrick';

export const GovernmentOverlaysBrickWithData: FunctionComponent = () => {
  const propertyPage = usePropertyPageQuery()?.data.propertyPageBySlugV3;
  if (!propertyPage?.governmentDataV3) return null;

  const { title, subtitle, landDescription, overlayTiles, overlayDetails, moreInformation } =
    propertyPage.governmentDataV3;

  return (
    <GovernmentOverlaysBrick
      title={title}
      subtitle={subtitle}
      overlayTiles={overlayTiles}
      overlayDetails={overlayDetails}
      landDescription={landDescription}
      moreInformation={moreInformation}
    />
  );
};
